<template>
    <div>
        <div class="topimg" style="height: 225px;margin-top: 124px;"></div>
        <div class="layui-container">
            <div class="container" style="width: 1024px; margin: 0 auto;">
                <p class=" animated fadeInUp"
                    style="font-size: 16px; font-weight: bold; color: #019f6a; height: 40px; line-height: 40px; border-bottom: 1px solid #ccc;">
                    关于我们</p>
                <p class=" animated fadeInRight" style="font-size: 14px; color: #666; line-height: 40px; overflow: hidden;">
                    自发卡支付-ZIFAKA.COM，专注为全行业提供专业的支付解决方案，致力于帮助开发者轻松、便捷地接入各类支付服务。<br>凭借多渠道兑换计费网关程序，确保支付过程的安全与稳定。<br>我们始终如一地为客户提供服务，成为您值得信赖的订单计数系统伙伴！</p>
                <p class=" animated fadeInUp"
                    style="font-size: 16px; font-weight: bold; color: #019f6a; height: 40px; line-height: 40px; border-bottom: 1px solid #ccc;">
                    温馨提示</p>
                <p class=" animated fadeInRight" style="font-size: 14px; color: #666; line-height: 40px; overflow: hidden;">
                    自发卡ZIFAKA.COM无代收代付业务，仅提供计费系统网关服务，根据商户累计使用网关额度收取0.4%系统服务费。<br>使用我司网关系统需准备以下资料进件:<br>个体/小微:营业执照 法人身份证(正反)照片 结算银行卡 法人实名手机号。<br>企业:营业执照 法人身份证(正反)照片 企业对公账户 法人实名手机号。<br>上述材料依据第三方支付机构商户准入审核标准进行收集。<br>若贵司已完成第三方支付渠道对接，可直接联系业务经理对接贵司现有支付渠道，合法合规的使用自发卡计费系统。</p>    
                <p class=" animated fadeInUp"
                    style="font-size: 16px; font-weight: bold; color: #019f6a; height: 40px; line-height: 40px; border-bottom: 1px solid #ccc;">
                    私有化部署</p>    
                <p class=" animated fadeInRight" style="font-size: 14px; color: #666; line-height: 40px; overflow: hidden;">
                    1.系统使用Docker一键部署，我司提供免费的部署和维护服务，服务器硬件配置要求4H8G。</p>
                <p class=" animated fadeInRight" style="font-size: 14px; color: #666; line-height: 40px; overflow: hidden;">
                    2.系统授权使用费:500/年，可联系我司商务经理查看功能演示站。</p>                       
                <p class=" animated fadeInUp"
                    style="font-size: 16px; font-weight: bold; color: #019f6a; height: 40px; line-height: 40px; border-bottom: 1px solid #ccc;">
                    联系方式</p>    
                <p class=" animated fadeInRight" style="font-size: 14px; color: #666; line-height: 40px; overflow: hidden;">
                    商务经理QQ:1831119191 </p>
                <p class=" animated fadeInRight" style="font-size: 14px; color: #666; line-height: 40px; overflow: hidden;">
                    商务邮箱:zifaka@yeah.net</p>    
                 <!-- <p class=" animated fadeInUp"
                    style="font-size: 16px; font-weight: bold; color: #019f6a; height: 40px; line-height: 40px; border-bottom: 1px solid #ccc;">
                    客服QQ</p>
                <div class="col-sm-12" style=" overflow: hidden;    margin-bottom: 30px;">
                    <div class="kefulianxi"
                        style="height: 280px; border: 1px solid #ccc; margin-top: 10px; float: left;width: 16.666%;margin-right: 40px;flex">
                        <div class="kefu1" style="position: relative;">
                            <img src="@/assets/themes/images/yw.png"
                                style="width: 150px; position: relative; left: 50%; top: 20px; margin-left: -75px;">
                            <h4
                                style="text-align: center; margin-top: 30px; font-weight: bold;font-size: 18px;margin-bottom: 0;">
                                客服</h4>
                            <p style="text-align: center; margin-top: 10px;">QQ: 76120673</p>
                            <a href="tencent://AddContact/?fromId=50&fromSubId=1&subcmd=all&uin=76120673"><img
                                    src="@/assets/themes/images/qq.gif"
                                    style="position: relative; left: 50%; top: 10px; margin-left: -75px;"></a>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'contactus',
}
</script>
<style scoped>
.topimg {
    height: 225px;
    background: url('../../assets/themes/images/subbanner.jpg') no-repeat center bottom;
}
</style>